import { FC } from 'react';
import { Grid } from '@mui/material';
import { EspacioProteccion } from '../../../../../../types/ObraDetails';
import { useTranslation } from 'react-i18next';
import MultipleSelectView from '../multipleSelectView';
import TitleValue from '../../../../components/titleValue/titleValue';

interface ProtectedSpaceRowProps {
  key: number;
  space: EspacioProteccion;
  editable: boolean;
}

const ProtectedSpaceRow: FC<ProtectedSpaceRowProps> = (props) => {
  const {
    key,
    space,
  } = props;
  const [t] = useTranslation();

  const getFormattedArea = (value?: string | number | null) => {
    if (value) {
      let area;
      const parts = value.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      if (parts.length == 2) {
        area = parts[0] + ',' + parts[1];
      } else {
        area = parts[0];
      }
      return area;
    } else if (value === 0) {
      return 0;
    }
    return null;
  };

  return (
    <Grid
      key={`${space.nombre}-${key}`}
      container
      spacing={2}
    >
      <Grid item xs>
        <MultipleSelectView id="protectedSpaces" label={t('details.location.labelProtectedSpaces')} values={space.areasProtegidas ?? []}/>
      </Grid>
      <Grid item xs>
        <TitleValue
          identifier="location-protectedArea"
          title={t('details.location.protectedArea')}
          value={getFormattedArea(space.superficieArea)}
          valueMaxLength={25}
          isDecimalNumber
          onlyView={true}
        />
      </Grid>
      <Grid item xs>
        <TitleValue
          identifier={`location-location-${key}`}
          title={t('details.location.location')}
          value={space.ubicacion ? space.ubicacion.nombre : ''}
          valueMaxLength={25}
          onlyView={true}
        />
      </Grid>
      <Grid item xs>
        <TitleValue
          identifier="location-projectArea"
          title={t('details.location.projectArea')}
          value={getFormattedArea(space.superficieProyecto)}
          valueMaxLength={25}
          isDecimalNumber
          onlyView={true}
        />
      </Grid>
    </Grid>
  );
};

export default ProtectedSpaceRow;
